import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import DashboardFilters from '~/pages/Dashboard/components/DashboardFilters/';
import DashboardContent from '~/pages/Dashboard/components/DashboardContent/';
import { PrivateLayout } from '~/pages';
import { flushSelectedMatch } from '~/store/modules/matches/actions';
import * as S from './styles';

const Dashboard = ({ location }) => {
  const dispatch = useDispatch();
  const {
    selectedMatch: { data: selectedMatch },
  } = useSelector(state => state.matches);

  useEffect(() => {
    if (selectedMatch !== null) {
      dispatch(flushSelectedMatch());
    }
  }, [dispatch, selectedMatch]);

  return (
    <PrivateLayout subHeader={null} location={location}>
      <S.DashboardContainer>
        <DashboardFilters />
        <DashboardContent />
      </S.DashboardContainer>
    </PrivateLayout>
  );
};

Dashboard.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
    pathname: PropTypes.string,
  }).isRequired,
};

export default Dashboard;
